import { render, staticRenderFns } from "./FeaturesSelection.vue?vue&type=template&id=237e6198&scoped=true"
import script from "./FeaturesSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeaturesSelection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e6198",
  null
  
)

export default component.exports